import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { ITeam } from "MVVM/@types";
import { Flex, Text } from "rebass/styled-components";

interface TeamBadgeProps {
  team: ITeam | undefined;
  size?: "small" | "default";
  isClickable?: boolean;
}

export const TeamBadge = ({
  team,
  size = "default",
  isClickable = true,
}: TeamBadgeProps) => {
  const history = useHistory();

  if (!team) return null;

  const handleClick = () => {
    if (team.slug && isClickable) {
      history.push(`/team/${team.slug}`);
    }
  };

  return (
    <StyledBadge isClickable={isClickable} onClick={handleClick} size={size}>
      {team.tagImageUrl && (
        <StyledBadgeIcon size={size}>
          <img src={team.tagImageUrl} alt={`${team.tag} badge`} />
        </StyledBadgeIcon>
      )}
      <StyledBadgeText size={size}>{team.tag}</StyledBadgeText>
    </StyledBadge>
  );
};

const StyledBadge = styled(Flex)<{
  size: "small" | "default";
  isClickable: boolean;
}>`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy50};
  border-radius: 4px;
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.4));
  gap: ${({ size }) => (size === "small" ? "3px" : "4px")};
  height: ${({ size }) => (size === "small" ? "20px" : "30px")};
  padding: ${({ size }) => (size === "small" ? "0px 6px" : "0px 10px")};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`;

const StyledBadgeIcon = styled(Flex)<{ size: "small" | "default" }>`
  align-items: center;
  height: ${({ size }) => (size === "small" ? "14px" : "20px")};
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.4));
  }
  justify-content: center;
  width: ${({ size }) => (size === "small" ? "14px" : "20px")};
`;

const StyledBadgeText = styled(Text)<{ size: "small" | "default" }>`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow, sans-serif;
  font-weight: 600;
  font-size: ${({ size }) => (size === "small" ? "12px" : "14px")};
  line-height: 1;
  margin: 0;
  padding: 0;
`;
